export { REGIONS } from './data';
export type { Country } from './data';
export { populateRegions } from './populate';
